import { useEffect, useState } from "react";
import { staticPagesMap } from "../../constants/constants";
import axios from "axios";
import styles from "./StaticPages.module.css";
import { AppConfig } from "../../utils/config";
import { cleanHtmlString } from "../../utils/constants";
import Loading from "../../components/Loader/Loader";
import { usePageMeta, staticPageMeta } from "../../hooks/usePageMeta";

const staticId = staticPagesMap["About"];

export default function AboutUs() {
  const [staticText, setStaticText] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const metaTags = usePageMeta(staticPageMeta.About);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${AppConfig.apiUrl}/static/${staticId}`)
      .then((res) => {
        setStaticText(res.data.Content);
        setIsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      {metaTags}
      <div className={styles.contactContainer}>
        <div className={styles.editableBanner}>About Us</div>
        <div className={styles.contentWrapper}>
          {isLoading ? (
            <div className={styles.loadingContainer}>
              <Loading fullscreen={false} />
            </div>
          ) : (
            <div
              className={styles.contactContent}
              dangerouslySetInnerHTML={{
                __html: cleanHtmlString(staticText).replace(/\\r\\n/g, "\n"),
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}
